import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { DoctorSpeciality } from "./idoctor-speciality";


@Injectable({ providedIn: 'root' })
export class DoctorSpecialityService {

    private _speciality: BehaviorSubject<DoctorSpeciality | null> = new BehaviorSubject<DoctorSpeciality | null>(null);
    private _specialities: BehaviorSubject<DoctorSpeciality[]> = new BehaviorSubject<DoctorSpeciality[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get speciality$(): Observable<DoctorSpeciality | null> {
        return this._speciality.asObservable();
    }

    get specialities$(): Observable<DoctorSpeciality[]> {
        return this._specialities.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getAllSpeciality(Specialitydata: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; specialities: DoctorSpeciality[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; specialities: DoctorSpeciality[] }>>(`${environment.baseURl}/Speciality/list`, Specialitydata).pipe(
            tap((response) => {
                
                this._pagination.next(response.result.pagination);
                this._specialities.next(response.result.specialities);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createSpeciality(speciality: DoctorSpeciality): Observable<BaseRespone<DoctorSpeciality>> {
        return this._httpClient.post<BaseRespone<DoctorSpeciality>>(`${environment.baseURl}/Speciality`, speciality)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                }),
                catchError((error) => {
                    console.error('Error to Fetching data:', error);
                    throw error;
                })
            )
    }

    deleteSpeciality(id: number): Observable<BaseRespone<boolean>> {
        return this.specialities$.pipe(
            take(1),
            switchMap(speciality =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Speciality/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = speciality.filter(item => item.id !== id);
                            this._specialities.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateSpeciality(speciality: DoctorSpeciality): Observable<BaseRespone<DoctorSpeciality>> {
        return this.specialities$.pipe(
            take(1),
            switchMap(Specialities => this._httpClient.put<BaseRespone<DoctorSpeciality>>(`${environment.baseURl}/Speciality`, speciality).pipe(
                map((updated: BaseRespone<DoctorSpeciality>) => {

                    // Find the index of the updated product
                    const index = Specialities.findIndex(item => item.id === speciality.id);

                    // Update the product
                    Specialities[index] = speciality;

                    // Update the products
                    this._specialities.next(Specialities);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                return of(error.error);
            })
        );
    }


}
